export interface WeatherStation {
  id: string;
  name: string;
  resort: 'levi' | 'yllas';
  lat: number;
  lon: number;
  elevation: number;
  description: string;
}

export const weatherStations: WeatherStation[] = [
  {
    id: 'kittila-airport',
    name: 'Kittilä Airport',
    resort: 'levi',
    lat: 67.70,
    lon: 24.85,
    elevation: 194,
    description: 'Nearest station to Levi (~15km)',
  },
  {
    id: 'kittila-kenttarova',
    name: 'Kittilä Kenttärova',
    resort: 'yllas',
    lat: 67.99,
    lon: 24.24,
    elevation: 306,
    description: 'Fell-level conditions near Ylläs',
  },
];

export const fmiPlaces = {
  levi: 'sirkka',
  yllas: 'muonio',
} as const;

// Stations that actually report snow_aws and r_1h (the main fmiPlaces stations may not)
export const fmiSnowPlaces = {
  levi: 'Kittilä',  // Kittilä Pakatti (fmisid 101990) - reports snow_aws, r_1h
  yllas: 'muonio',
} as const;

export const weatherIconMap: Record<number, string> = {
  1: 'Sun',
  2: 'CloudSun',
  3: 'Cloud',
  21: 'CloudRain',
  22: 'CloudRain',
  23: 'CloudRain',
  31: 'CloudSnow',
  32: 'CloudSnow',
  33: 'CloudSnow',
  41: 'CloudDrizzle',
  42: 'CloudDrizzle',
  43: 'CloudDrizzle',
  51: 'CloudHail',
  52: 'CloudHail',
  53: 'CloudHail',
  61: 'CloudLightning',
  62: 'CloudLightning',
  63: 'CloudLightning',
  71: 'CloudFog',
  72: 'CloudFog',
  73: 'CloudFog',
};

export const cloudCoverDescriptions: Record<number, string> = {
  0: 'Clear sky',
  1: 'Mostly clear',
  2: 'Partly cloudy',
  3: 'Partly cloudy',
  4: 'Partly cloudy',
  5: 'Mostly cloudy',
  6: 'Mostly cloudy',
  7: 'Overcast',
  8: 'Overcast',
};

export interface MonthlyAverage {
  month: string;
  avgTemp: string;
  snowDepth: string;
  daylightHours: string;
  bestFor: string;
}

export const monthlyAverages: MonthlyAverage[] = [
  { month: 'Nov', avgTemp: '-8°C', snowDepth: '30 cm', daylightHours: '6h', bestFor: 'Early season skiing, first auroras' },
  { month: 'Dec', avgTemp: '-14°C', snowDepth: '50 cm', daylightHours: '0h (polar night)', bestFor: 'Northern lights, Christmas magic' },
  { month: 'Jan', avgTemp: '-15°C', snowDepth: '60 cm', daylightHours: '2h', bestFor: 'Deep winter, aurora peak' },
  { month: 'Feb', avgTemp: '-13°C', snowDepth: '70 cm', daylightHours: '8h', bestFor: 'Best snow, returning light' },
  { month: 'Mar', avgTemp: '-8°C', snowDepth: '80 cm', daylightHours: '12h', bestFor: 'Spring skiing, sunny days' },
  { month: 'Apr', avgTemp: '-2°C', snowDepth: '75 cm', daylightHours: '16h', bestFor: 'Late skiing, warm sun' },
  { month: 'May', avgTemp: '5°C', snowDepth: '20 cm', daylightHours: '21h', bestFor: 'Season end, snow melting' },
  { month: 'Jun', avgTemp: '12°C', snowDepth: '0 cm', daylightHours: '24h (midnight sun)', bestFor: 'Hiking, biking, fishing' },
  { month: 'Jul', avgTemp: '15°C', snowDepth: '0 cm', daylightHours: '22h', bestFor: 'Peak summer, warmest' },
  { month: 'Aug', avgTemp: '12°C', snowDepth: '0 cm', daylightHours: '17h', bestFor: 'Berry picking, autumn starts' },
  { month: 'Sep', avgTemp: '6°C', snowDepth: '0 cm', daylightHours: '12h', bestFor: 'Ruska (autumn colours)' },
  { month: 'Oct', avgTemp: '-2°C', snowDepth: '10 cm', daylightHours: '8h', bestFor: 'First snow, aurora season starts' },
];

export type SnowRating = 'Poor' | 'Fair' | 'Good' | 'Excellent' | 'Epic';

export function getSnowRating(depthCm: number): SnowRating {
  if (depthCm < 20) return 'Poor';
  if (depthCm < 40) return 'Fair';
  if (depthCm < 70) return 'Good';
  if (depthCm < 100) return 'Excellent';
  return 'Epic';
}

export const snowRatingColors: Record<SnowRating, string> = {
  Poor: '#EF4444',
  Fair: '#F59E0B',
  Good: '#22C55E',
  Excellent: '#3B82F6',
  Epic: '#8B5CF6',
};
